import { render, staticRenderFns } from "./NutritionalGuidanceDetail.vue?vue&type=template&id=468bd7f3&scoped=true&"
import script from "./NutritionalGuidanceDetail.vue?vue&type=script&lang=js&"
export * from "./NutritionalGuidanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./NutritionalGuidanceDetail.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./NutritionalGuidanceDetail.vue?vue&type=style&index=1&id=468bd7f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468bd7f3",
  null
  
)

export default component.exports